import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Gift, Check, Megaphone, Sparkles, DollarSign, HeartHandshake } from 'lucide-react';
export function Bonuses() {
  const scrollToPricing = () => {
    const element = document.querySelector('#comprar');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const bonuses = [{
    id: 1,
    title: 'Sistema de Captación de Alumnos (orgánico)',
    icon: <Megaphone className="w-5 h-5 md:w-6 md:h-6" data-id="element-20" />,
    image: 'https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?q=80&w=2070&auto=format&fit=crop',
    items: ['Ideas de contenido para redes (Reels, carruseles)', 'Hooks listos tipo "Aprendé coreano sin memorizar..."', 'Guiones cortos para grabar', 'CTA para convertir seguidores en alumnos']
  }, {
    id: 2,
    title: 'Guía de Primera Clase Perfecta',
    icon: <Sparkles className="w-5 h-5 md:w-6 md:h-6" data-id="element-21" />,
    image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?q=80&w=2070&auto=format&fit=crop',
    items: ['Qué decir en los primeros 5 minutos', 'Cómo detectar nivel rápido', 'Cómo generar confianza', 'Cómo cerrar la clase para que vuelvan']
  }, {
    id: 3,
    title: 'Sistema de Precios y Paquetes',
    icon: <DollarSign className="w-5 h-5 md:w-6 md:h-6" data-id="element-22" />,
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=2071&auto=format&fit=crop',
    items: ['Modelos de precios (individual, grupal)', 'Packs mensuales', 'Cómo justificar precio', 'Scripts para comunicar aumentos']
  }, {
    id: 4,
    title: 'Kit Anti-Abandono (Retención de Alumnos)',
    icon: <HeartHandshake className="w-5 h-5 md:w-6 md:h-6" data-id="element-23" />,
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop',
    items: ['Mensajes para reactivar alumnos', 'Seguimiento simple semanal', 'Mini sistema de motivación', 'Alertas de abandono (señales clave)']
  }];
  return <section className="py-12 md:py-24 bg-brand-950 text-white relative overflow-hidden" data-id="element-24">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-25"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-26">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-27">
          <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 rounded-full bg-accent-500/20 text-accent-400 font-bold mb-3 md:mb-6 border border-accent-500/30 text-xs md:text-base" data-id="element-28">
            <Gift className="w-4 h-4 md:w-5 md:h-5" data-id="element-29" />
            <span data-id="element-30">GRATIS SOLO POR HOY</span>
          </div>
          <h2 className="text-2xl md:text-5xl font-extrabold mb-2 md:mb-6" data-id="element-31">
            Bonos exclusivos{' '}
            <span className="text-brand-300 font-medium block md:inline text-base md:text-5xl" data-id="element-32">
              (incluidos hoy)
            </span>
          </h2>
          <p className="text-sm md:text-base text-brand-300 px-2" data-id="element-33">
            Además del sistema completo, te llevás 4 bonos para conseguir
            alumnos, cobrar mejor y retenerlos.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto mb-8 md:mb-16" data-id="element-34">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} onClick={scrollToPricing} className="bg-brand-900 rounded-xl md:rounded-2xl overflow-hidden border border-brand-800 hover:border-accent-500/50 transition-all cursor-pointer group shadow-lg hover:shadow-[0_0_30px_rgba(239,68,68,0.15)] flex flex-col" data-id="element-35">
              <div className="h-28 md:h-40 overflow-hidden relative shrink-0" data-id="element-36">
                <div className="absolute inset-0 bg-gradient-to-b from-brand-900/10 to-brand-900/60 group-hover:from-transparent group-hover:to-brand-900/40 transition-colors z-10" data-id="element-37"></div>
                <div className="absolute top-2 left-2 md:top-3 md:left-3 z-20 bg-accent-600 text-white text-[10px] md:text-xs font-bold px-2 py-1 rounded shadow-md flex items-center gap-1" data-id="element-38">
                  <Gift className="w-3 h-3" data-id="element-39" />
                  <span data-id="element-40">BONO {bonus.id}</span>
                </div>
                <div className="absolute bottom-2 right-2 md:bottom-3 md:right-3 z-20 bg-white/10 backdrop-blur-md border border-white/20 text-white p-2 rounded-lg" data-id="element-41">
                  {bonus.icon}
                </div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-42" />
              </div>
              <div className="p-4 md:p-6 flex flex-col flex-1" data-id="element-43">
                <h3 className="text-base md:text-xl font-bold mb-2 md:mb-4 leading-tight group-hover:text-accent-400 transition-colors" data-id="element-44">
                  🎁 {bonus.title}
                </h3>
                <ul className="space-y-1.5 md:space-y-2 flex-1" data-id="element-45">
                  {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-brand-200" data-id="element-46">
                      <div className="mt-1 bg-accent-500/20 p-0.5 rounded-full shrink-0" data-id="element-47">
                        <Check className="w-3 h-3 md:w-3.5 md:h-3.5 text-accent-400" data-id="element-48" />
                      </div>
                      <span className="text-xs md:text-sm font-medium leading-snug" data-id="element-49">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-gradient-to-r from-brand-900 to-brand-800 border border-brand-700 rounded-xl md:rounded-2xl p-5 md:p-8 text-center shadow-2xl" data-id="element-50">
          <p className="text-lg md:text-3xl font-bold mb-1 md:mb-2" data-id="element-51">
            Valor total de bonos:{' '}
            <span className="text-red-400 line-through decoration-red-500/50 block sm:inline" data-id="element-52">
              $60.000 ARS
            </span>
          </p>
          <p className="text-sm md:text-xl text-accent-400 font-extrabold uppercase tracking-wide" data-id="element-53">
            Incluidos hoy sin costo adicional
          </p>
        </motion.div>
      </div>
    </section>;
}